import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/primeng';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FinanceiroService } from '../financeiro.service';
import { UnidadeService } from '../../shared/services/unidade.service';

@Component({
  selector: 'sispac-cadastrar-lancamento-form',
  templateUrl: './cadastrar-lancamento-form.component.html',
  styleUrls: ['./cadastrar-lancamento-form.component.css']
})
export class CadastrarLancamentoFormComponent extends WebPage implements OnInit {
  public idLancamento: any;
  public idTipoTransacao: string;
  public idTipoFornecedor: string;
  public lancamento: any;
  public form: FormGroup;
  public tipoFornecedores: any[];
  public desabilitarCampo = false;
  public nomeFormulario = 'Cadastar';

  constructor(messageService: MessageService,
    private fb: FormBuilder,
    private _financeiroService: FinanceiroService,
    private _unidadeService: UnidadeService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService, ) {
    super(messageService);
    this.route.paramMap.subscribe(params => {
      if (params.has('id')) {
        this.idLancamento = params.get('id');
      }
    });
  }

  ngOnInit() {
    this.getTipoFornecedores();
    // console.log(this.idLancamento);
    if (this.idLancamento !== undefined && this.idLancamento !== null) {
      this.getLancamento();
      this.desabilitarCampo = this.router.url.includes('visualizar');
      this.desabilitarCampo ? this.nomeFormulario = 'Visualizar' : this.nomeFormulario = 'Editar';
    }
  }

  getTipoFornecedores() {
    this._financeiroService.getAllTipoForcecedores()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.tipoFornecedores = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        // const arquivosNovos = this.arquivos.controls.filter(arquivo => !arquivo.value.isOld);
        // arquivosNovos.concat(this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld));
        // this.removeArquivosDoBanco(arquivosNovos);

        this.router.navigate(['/gerenciar-prestacao-conta']);
      }
    });
  }

  recebeFormulario(recebeForm) {
    console.log('recebe form filho');
    // console.log(recebeForm);
    // if (recebeForm.valid) {

    this.isLoading = true;
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja salvar este registro?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        console.log(recebeForm.value);
        this._financeiroService.cadastrarEditarLancamento(recebeForm)
          .finally(() => this.isLoading = false)
          .subscribe(
            data => {
              localStorage.setItem('mensagem', 'Cadastro salvo com sucesso!');
              // this.router.navigate(['/gerenciar-prestacao-contas']);
            },
            error => {
              this.isLoading = false;
              this.gerenciaErro(error);
            }
          );
      },
      reject: () => {
        this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });

    // } else {
    // this.isSubmitted = false;
    // }

  }

  getLancamento() {
    // this._financeiroService.getByIdLancamento(this.idLancamento)
    this._financeiroService.getLancamentoSimplificado(this.idLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.lancamento = data;
          this.setValues();
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  setValues() {
    this.idTipoTransacao = this.lancamento.idTipoTransacao.toUpperCase();
    this.lancamento.idTipoFornecedor !== null ?
    this.idTipoFornecedor = this.lancamento.idTipoFornecedor.toUpperCase() : this.idTipoFornecedor = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/cadastrar-lancamento-form/cadastrar-lancamento-form.component.ts